export default '/static/frontend/ReachDigital/12gobiking/dist/assets/postnl-236f6648.svg'